import { render, staticRenderFns } from "./WebPartSlickerImage3Designer.vue?vue&type=template&id=5bd51c50&scoped=true&"
import script from "./WebPartSlickerImage3Designer.vue?vue&type=script&lang=js&"
export * from "./WebPartSlickerImage3Designer.vue?vue&type=script&lang=js&"
import style0 from "./WebPartSlickerImage3Designer.vue?vue&type=style&index=0&id=5bd51c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd51c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd51c50')) {
      api.createRecord('5bd51c50', component.options)
    } else {
      api.reload('5bd51c50', component.options)
    }
    module.hot.accept("./WebPartSlickerImage3Designer.vue?vue&type=template&id=5bd51c50&scoped=true&", function () {
      api.rerender('5bd51c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartSlickerImage3Designer.vue"
export default component.exports